import React, { useState, useEffect } from 'react';
import CarouselArrow from '../../../CarouselArrow/CarouselArrow';
import ModalMessage from '../../Modal/ModalMessage';
import ModalConfirm from '../../Modal/ModalConfirm';
import '../../../../components/Home/Depoimentos/style.css';
import './SectionDepoimentos.css';

const tabs = [
  { key: 'atendidos', label: 'Atendidos' },
  { key: 'familiares', label: 'Familiares' },
  { key: 'colaboradores', label: 'Colaboradores' },
  { key: 'parceiros', label: 'Parceiros' },
];

export default function SectionDepoimentos({
  isEditing,
  depoimentos,
  setDepoimentos,
  fraseInstitucional,
  setFraseInstitucional
}) {
  const [activeTab, setActiveTab] = useState('atendidos');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalMessage, setModalMessage] = useState('');
  const [isModalMessageOpen, setIsModalMessageOpen] = useState(false);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);

  // Filtra os depoimentos correspondentes à categoria selecionada
  const depoimentosAtuais = depoimentos.filter((dep) => dep.category === activeTab);
  
  // Define o depoimento atualmente visível no carrossel
  const atual = depoimentosAtuais[currentIndex];

  // Reseta o índice do carrossel ao trocar de categoria
  useEffect(() => {
    setCurrentIndex(0);
  }, [activeTab]);

  // Retorna o índice global do depoimento atual no array principal
  const getGlobalIndex = () => {
    if (!atual) return -1;
    return depoimentos.findIndex(dep => dep === atual);
  };

  // --- NAVEGAÇÃO DO CARROSSEL ---
  const prev = () => {
    if (depoimentosAtuais.length === 0) return;
    setCurrentIndex((curr) => (curr > 0 ? curr - 1 : depoimentosAtuais.length - 1));
  };

  const next = () => {
    if (depoimentosAtuais.length === 0) return;
    setCurrentIndex((curr) => (curr < depoimentosAtuais.length - 1 ? curr + 1 : 0));
  };

  // --- MANIPULADORES DE ESTADO (EDIÇÃO) ---
  const handleChange = (campo, valor) => {
    const globalIndex = getGlobalIndex();
    if (globalIndex === -1) return;

    const novos = [...depoimentos];
    novos[globalIndex] = { ...novos[globalIndex], [campo]: valor };
    setDepoimentos(novos);
  };

  const handleImageUpload = (event) => {
    const globalIndex = getGlobalIndex();
    const file = event.target.files[0];
    
    if (!file || globalIndex === -1) return;

    // Validação de formato da imagem
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      setModalMessage('Formato inválido. A imagem deve ser JPG ou PNG.');
      setIsModalMessageOpen(true);
      return;
    }

    // Validação de tamanho (Limite: 15MB)
    if (file.size > 15 * 1024 * 1024) {
      setModalMessage('A imagem é muito grande. O tamanho máximo permitido é 15MB.');
      setIsModalMessageOpen(true);
      return;
    }

    const novos = [...depoimentos];
    novos[globalIndex] = { 
      ...novos[globalIndex], 
      photoUrl: URL.createObjectURL(file), 
      file: file 
    };
    setDepoimentos(novos);
  };

  // --- ADIÇÃO E REMOÇÃO DE DEPOIMENTOS ---
  const handleAdd = () => {
    const novoDepoimento = {
      id: Date.now().toString(), // Gera um ID temporário único para o front-end
      category: activeTab,
      name: '',
      nucleo: '',
      text: '',
      photoUrl: 'https://via.placeholder.com/280?text=Nova+Foto',
      file: null,
    };
    
    const novos = [...depoimentos, novoDepoimento];
    setDepoimentos(novos);
    
    // Atualiza o índice para focar no depoimento recém-criado
    const countNaAba = novos.filter((d) => d.category === activeTab).length;
    setCurrentIndex(countNaAba - 1);
  };

  const handleRemove = () => {
    if (!atual) return;
    setIsModalConfirmOpen(true);
  };

  const handleConfirmRemove = () => {
    const globalIndex = getGlobalIndex();
    if (globalIndex !== -1) {
      const novos = [...depoimentos];
      // Remove o item exato baseado na referência global
      novos.splice(globalIndex, 1);
      setDepoimentos(novos);
    }
    
    // Ajusta o índice do carrossel para evitar quebra de interface ao remover o último item da lista
    if (currentIndex > 0 && currentIndex >= depoimentosAtuais.length - 1) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex(0);
    }
    
    setIsModalConfirmOpen(false);
  };

  return (
    <section className="depoimentos">
      <div className="depoimentos__inner">
        
        {isEditing ? (
          <div className="depoimentos__titulo-principal-edit">
            <input
              type="text"
              className="depoimentos__titulo-principal-input"
              value={fraseInstitucional}
              onChange={(e) => setFraseInstitucional(e.target.value)}
              placeholder="Transformando vidas e impactando gerações"
            />
          </div>
        ) : (
          <h2 className="depoimentos__titulo-principal">
            {fraseInstitucional || 'Transformando vidas e impactando gerações'}
          </h2>
        )}

        <div className="depoimentos__cabecalho">
          <h3 className="depoimentos__titulo-secao">Depoimentos</h3>

          <nav className="depoimentos__tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`depoimentos__tab ${activeTab === tab.key ? 'depoimentos__tab--ativo' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="depoimentos__carrossel">
          <CarouselArrow
            direction="prev"
            className="depoimentos__seta"
            onClick={prev}
            ariaLabel="Depoimento anterior"
          />

          {depoimentosAtuais.length === 0 ? (
            <p className="depoimentos__vazio">
              Ainda não há depoimentos nessa categoria.
            </p>
          ) : (
            <div className="depoimentos__card">
              <div className="depoimentos__foto">
                {atual?.photoUrl ? (
                  <img key={atual.photoUrl} src={atual.photoUrl} alt={atual?.name || 'Depoimento'} />
                ) : (
                  <div className="depoimentos__foto-placeholder" />
                )}

                {isEditing && (
                  <label className="depoimentos__foto-overlay">
                    <input type="file" accept=".jpg, .jpeg, .png" onChange={handleImageUpload} hidden />
                    <svg viewBox="0 0 24 24" width="24" height="24" fill="#fff">
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5-7l-3 3.72L9 13l-3 4h14l-4-5z" />
                    </svg>
                    <span>Trocar Foto</span>
                  </label>
                )}
              </div>

              <div className="depoimentos__texto">
                {isEditing ? (
                  <div className="depoimentos__edit-fields">
                    <textarea
                      className="admin-input admin-input--text"
                      value={atual?.text || ''}
                      onChange={(e) => handleChange('text', e.target.value)}
                      placeholder="Texto do depoimento"
                      rows="4"
                    />
                    <input
                      type="text"
                      className="admin-input admin-input--name"
                      value={atual?.name || ''}
                      onChange={(e) => handleChange('name', e.target.value)}
                      placeholder="Nome do autor"
                    />
                    <input
                      type="text"
                      className="admin-input admin-input--nucleo"
                      value={atual?.nucleo || atual?.local || ''}
                      onChange={(e) => handleChange('nucleo', e.target.value)}
                      placeholder="Núcleo / Local"
                    />
                    <button type="button" className="btn-remover-depoimento" onClick={handleRemove}>
                      Excluir Depoimento
                    </button>
                  </div>
                ) : (
                  <>
                    <p>"{atual?.text}"</p>
                    <strong>{atual?.name}</strong>
                    {(atual?.nucleo || atual?.local) && <span>{atual?.nucleo || atual?.local}</span>}
                  </>
                )}
              </div>
            </div>
          )}

          <CarouselArrow
            direction="next"
            className="depoimentos__seta"
            onClick={next}
            ariaLabel="Próximo depoimento"
          />
        </div>

        {isEditing && (
          <div className="depoimentos__add-container">
            <button type="button" className="btn-add-novo" onClick={handleAdd}>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
              Adicionar Novo Depoimento em "{tabs.find((t) => t.key === activeTab)?.label}"
            </button>
          </div>
        )}
      </div>

      <ModalMessage
        isOpen={isModalMessageOpen}
        onClose={() => setIsModalMessageOpen(false)}
        message={modalMessage}
      />

      <ModalConfirm
        isOpen={isModalConfirmOpen}
        onClose={() => setIsModalConfirmOpen(false)}
        onConfirm={handleConfirmRemove}
        message="Confirmar a exclusão deste depoimento?"
      />
    </section>
  );
}
